import { combineReducers } from 'redux-immutable';
import { routerReducer } from 'react-router-redux';
import pacerSearchResults from './pacerSearchResults';
import caseLookupSearchReducer from './caseLookupSearchReducer';
import reportsTabReducer from './reportsTabReducer';
import searchErrors from './searchErrors';
import validationErrors from './validationErrors';
import loadingSpinner from './loadingSpinner';
import user from './user';
import immediateSearch from './immediateSearch';
import { sidebarData } from '../actions/sidebarActions';
import kloudless from './kloudlessReducer';
import irSearch from './irSearch';
import integrations from './integrationsReducer';
import docketReducer from './docketReducer';
import searchAlerts from './searchAlertsReducer'

export default combineReducers({
  routerReducer,
  pacerSearchResults,
  caseLookupSearchReducer,
  reportsTabReducer,
  searchErrors,
  validationErrors,
  loadingSpinner,
  user,
  irSearch,
  immediateSearch,
  sidebarData,
  kloudless,
  integrations,
  dockets: docketReducer,
  searchAlerts,
});



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/rootReducer.js
 **/